import Cookies from "js-cookie";

const COOKIE_EXPIRATION = 48 / 24; // 48 hours (2 days)

const COOKIE_OPTIONS = {
  secure: true,
  sameSite: "strict" as const,
  path: "/",
  expires: COOKIE_EXPIRATION,
};

/**
 * Sets valuation report related cookies (realEstateId and session)
 * with consistent settings across the application
 */
export const setValuationReportCookies = (params: { realEstateId?: string | null; session?: string | null }): void => {
  const { realEstateId, session } = params;

  if (realEstateId) {
    Cookies.set("realEstateId", realEstateId, COOKIE_OPTIONS);
  }

  if (session) {
    Cookies.set("session", session, COOKIE_OPTIONS);
  }
};

/**
 * Gets valuation report related cookies
 */
export const getValuationReportCookies = (): {
  realEstateId: string | undefined;
  session: string | undefined;
} => ({
  realEstateId: Cookies.get("realEstateId"),
  session: Cookies.get("session"),
});

/**
 * Removes valuation report related cookies
 */
export const clearValuationReportCookies = (): void => {
  Cookies.remove("realEstateId", { path: "/" });
  Cookies.remove("session", { path: "/" });
};

/**
 * Gets realEstateId from URL params or cookies, and saves to cookie if found in URL
 */
export const getRealEstateIdAndSaveToCookie = (): string | null => {
  const urlParams = new URLSearchParams(window.location.search);
  let realEstateId: string | null = urlParams.get("realEstateId");

  if (realEstateId) {
    setValuationReportCookies({ realEstateId });
  } else {
    realEstateId = Cookies.get("realEstateId") || null;
  }

  return realEstateId;
};
